import { Button } from "@/components/ui/button";
import { Container, Section } from "@/components/ui/section";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Hero = () => {
  return (
    <Section id="hero" className="relative overflow-hidden bg-gradient-to-br from-background to-secondary/30 py-20">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <Container className="relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left column: Copy + CTAs */}
          <div className="text-center lg:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">Customer stories close deals. Casey collects them at scale.</h1>
            <p className="text-base sm:text-lg text-muted-foreground mb-8 max-w-2xl mx-auto lg:mx-0">
              Automate customer interviews and instantly generate the content your team needs - stories, case studies,
              testimonials, user stories, and sales assets - all from a single conversation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button size="lg" className="text-base sm:text-lg px-6 sm:px-8 py-6 h-auto gap-2" asChild>
                <Link to="/book-demo">
                  Get Started
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </Button>
            </div>
            <div className="mt-6 text-sm text-muted-foreground text-center lg:text-left space-y-2">
              <p>
                New to this category?{" "}
                <Link to="/what-is-customer-proof-automation" className="text-primary hover:underline">
                  Learn what customer proof automation is →
                </Link>
              </p>
              <p>
                <Link to="/resources" className="text-primary hover:underline">
                  Browse the Customer Proof Resource Library →
                </Link>
              </p>
            </div>
          </div>

          {/* Right column: Visual mock */}
          <div className="relative">
            <div className="bg-card border border-border rounded-lg shadow-[var(--shadow-soft)] p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-3 h-3 rounded-full bg-destructive"></div>
                <div className="w-3 h-3 rounded-full bg-accent"></div>
                <div className="w-3 h-3 rounded-full bg-primary"></div>
                <span className="ml-2 text-sm text-muted-foreground">Live Customer Interview with Casey</span>
              </div>
              <div className="space-y-4">
                <div className="bg-muted/50 rounded-lg p-4">
                  <p className="text-sm font-medium text-foreground mb-2">Casey:</p>
                  <p className="text-sm text-muted-foreground">
                    What was the main challenge you faced before using our product?
                  </p>
                </div>
                <div className="bg-primary/10 rounded-lg p-4">
                  <p className="text-sm font-medium text-foreground mb-2">Customer:</p>
                  <p className="text-sm text-muted-foreground">
                    We were spending 15+ hours per week manually processing reports...
                  </p>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-border">
                <p className="text-xs text-muted-foreground mb-3">Generated assets:</p>
                <div className="flex flex-wrap gap-2">
                  {["Case study", "Customer story", "Testimonial", "Sales one-pager", "User insights"].map((asset) => (
                    <span key={asset} className="text-xs px-3 py-1 bg-primary/10 text-primary rounded-full">
                      {asset}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
};
